import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTagCategoryOther = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1138_12526)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M14.0116 10.747L8.01634 14.2084L4.2385 7.66492L4.82279 5.2892L7.88418 3.5217L10.2337 4.20355L14.0116 10.747Z",
			stroke: "#1D1D1D"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M8.42329 5.90959C8.66481 6.32791 8.52148 6.86283 8.10316 7.10435C7.68484 7.34587 7.14993 7.20254 6.90841 6.78421C6.66689 6.36588 6.81022 5.83097 7.22854 5.58945C7.64686 5.34793 8.18177 5.49126 8.42329 5.90959Z",
			stroke: "#1D1D1D"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1138_12526",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 12.6545,
			height: 12.6546,
			fill: "white",
			transform: "translate(2.67285 2.67188)"
		})
	}) })]
});
export default SvgTagCategoryOther;
